import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-table-content-v2-loading',
  templateUrl: './main-table-content-v2-loading.component.html',
  styleUrls: ['./main-table-content-v2-loading.component.scss'],
  standalone: false,
})
export class MainTableContentV2LoadingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
